<template>
  <div ref="referralsCreditCard" class="referral-credit-card">
    <div>
      <h2>Referral Credit</h2>
      <p>Your Referral Credit</p>
    </div>
    <div>
      <h1>
        $ {{ (refCredit / 100).toFixed(2) }}
        <span>USD</span>
      </h1>
    </div>
    <div>
      <ButtonFilled
        @onButtonClicked="handleCashOut"
        text="Cash Out"
      ></ButtonFilled>
      <div style="height: 8px"></div>
    </div>
  </div>
</template>

<script>
import ButtonFilled from "../../common/ButtonFilled";
import { toastInstance } from "../../../main";
export default {
  components: {
    ButtonFilled,
  },
  data() {
    return {};
  },
  computed: {
    refCredit() {
      return this.$store.getters["userStore/getRefDetail"].currentBalance;
    },
  },
  async mounted() {
    await this.sleep(100);
    this.$refs.referralsCreditCard.style = "transform: scale(1) !important";
  },
  methods: {
    async handleCashOut() {
      try {
        this.$store.dispatch("userStore/toggleRefferalCashoutModal", true);
      } catch (e) {
        toastInstance.open({
          message: e.message,
          type: "error",
        });
      }
    },
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
  },
};
</script>

<style scoped>
.referral-credit-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  max-height: 275px;
  max-width: 30%;
  height: 265px;
  width: 30%;

  padding: 10px;
  background: radial-gradient(100% 100% at 44.04% 0%, #26292e 0%, #1a1c1f 100%);
  box-shadow: 2px 2px 5px #000000, inset 0px 1px 3px #000000;
  border-radius: 7px;
  transform: scale(0.5);
  transition: 0.4s;
}

.referral-credit-card > div > h2 {
  font-size: 22px !important;
  font-family: "OpenSans-SemiBold";
  text-align: center;
  color: #e0e0e0;
  margin-top: 15px;
}

.referral-credit-card > div > p {
  font-size: 12px !important;
  font-family: "OpenSans";
  text-align: center;
  color: #888888;
  margin-top: 5px;
}

.referral-credit-card > div > h1 {
  font-size: 46px !important;
  font-family: "OpenSans-SemiBold";
  text-align: center;
  color: #ffffff;
}
.referral-credit-card > div > h1 > span {
  color: #888888;
  font-size: 12px;
  font-family: "OpenSans";
}
</style>
